import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddAggregationModalComponent } from 'src/app/components/add-aggregation-modal/add-aggregation-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Execution, Portfolio, SectionByTool, SectionFileData } from 'src/app/models';
import { ExecutionService, PortfolioService, ToastService, FilesService } from 'src/app/services';

@Component({
    selector: 'app-add-edit-portfolio',
    templateUrl: './add-edit-portfolio.component.html',
    styleUrls: ['./add-edit-portfolio.component.scss'],
    standalone: false
})
export class AddEditPortfolioComponent implements OnInit {

  idExecution: string;
  execution: Execution;
  portfolios: Portfolio[];
  isInvalidSelectionForPortfolio = false;
  firstSelectArray = [];
  isContinueBtnAvailable = false;



    // questi servono fondamentalmente per il template dei portafogli.......
    isTemplateFill: boolean;
    toDeleteSection: SectionByTool[];
    chunkCount: number = 0;
    portfolioAssociationTemplate: SectionByTool = {
        data: [],
        description: "Upload here the portfolio association template.",
        //info: null,
        name: "PAT",
        type: "pat"

    }

  constructor(
    private executionService: ExecutionService,
    private portfolioService: PortfolioService,
    private toastService: ToastService,
    private modalService: NgbModal,
      private router: Router,
      private filesService: FilesService,
    private route: ActivatedRoute
    ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(async (params) => {
      this.idExecution = params.get('id');
      try {
        this.execution = await this.executionService.getToolInfo(this.idExecution);
        this.portfolios = (await this.portfolioService.getPortfolioConfiguration(this.idExecution)).portfolio_items;
        if (this.portfolios.some(item => item.attribute[0].chosen_values.length > 0)) {
          this.isContinueBtnAvailable = true;
          }
      } catch (error) {
        this.toastService.showError(error.error);
        console.error('error =>', error);
      }
    });
  }

    getFileFromInput(event : FileList, section: SectionByTool) { 
        const list = [];
        for (let i = 0; i < event.length; i++) {
            const file = event.item(i);
            this.chunkCount++;
            list.push({ file, id: this.chunkCount });
            section.data.unshift({ file, id: this.chunkCount });
        }
        try {
            Promise.all(
                list.map(async (item: SectionFileData) => {
                    await this.filesService.getFileNLLTemplateAssociation(this.idExecution, section.type, item.file, "A", "B")
                    this.updateSubTool();
                    this.portfolioService.getPortfolioConfiguration(this.idExecution)

                })
            ).then(res => this.portfolioService.getPortfolioConfiguration(this.idExecution)).then(p => {
                this.portfolios = p.portfolio_items
                if (this.portfolios.some(item => item.attribute[0].chosen_values.length > 0)) {
                    this.isContinueBtnAvailable = true;
                }
            } );  //GetPortfolioConfiguration
        } catch (error) {
            // Wrong error response
            this.toastService.showError(error.error);
            console.error('error =>', error);
        }
    }

    updateSubTool() {

    }


  /**
   * Opens the modal to create aggregations between multiple portfolios
   */

  openModal() {
    const modalRef = this.modalService.open(AddAggregationModalComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.idExecution = this.idExecution;
    modalRef.componentInstance.submit.subscribe(async (entry: boolean) => {
      if (entry) {
        try {
          this.portfolios = (await this.portfolioService.getPortfolioConfiguration(this.idExecution)).portfolio_items;
        } catch (error) {
          this.toastService.showError(error.error);
          console.error('error =>', error);
        }
      }
    });
  }

  /**
   * Delete aggregation and update portfolios
   * @param portfolioId Aggregation id
   */

  async getPortfolioId(portfolioId: string) {
    try {
      await this.portfolioService.deleteAggregation(this.idExecution, portfolioId);
      this.portfolios = (await this.portfolioService.getPortfolioConfiguration(this.idExecution)).portfolio_items;
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Execute execution
   */

  async continue() {
    try {
      const response = await this.portfolioService.executeAggregation(this.idExecution);
      if (response.status) {
        this.router.navigate([`tool/${this.execution.name_tool}/${this.idExecution}`]);
      }
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  getInvalidSelection() {
    this.isInvalidSelectionForPortfolio = true;
  }

  getAttributeInfo(portfolioId: string) {
    if (!this.firstSelectArray.includes(portfolioId)) {
      this.firstSelectArray.push(portfolioId);
    }
    if (this.portfolios.length === this.firstSelectArray.length) {
      this.isContinueBtnAvailable = true;
    }
  }
}
